// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: -F8ubDtD7Rb6
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import TimeSelectStack from "../../TimeSelectStack"; // plasmic-import: XwuZJuooVSGZ/component
import GraphStack from "../../GraphStack"; // plasmic-import: __SMOE36YGAw/component
import DashboardPaymentsCard from "../../DashboardPaymentsCard"; // plasmic-import: 1rItofzuaain/component
import DashboardContractsCard from "../../DashboardContractsCard"; // plasmic-import: S6vw5IJzcaua/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDashboard.module.css"; // plasmic-import: -F8ubDtD7Rb6/css

createPlasmicElementProxy;

export const PlasmicDashboard__VariantProps = new Array();

export const PlasmicDashboard__ArgProps = new Array(
  "startDate",
  "endDate",
  "accountBalance",
  "payouts",
  "totalBalance"
);

const $$ = {};

function PlasmicDashboard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <TopBar
              className={classNames("__wab_instance", sty.topBar__wcMwt)}
            />

            <TopBar
              className={classNames("__wab_instance", sty.topBar__reGje)}
              userNameText={"Jones Ferdinand"}
            />

            <div
              data-plasmic-name={"sheet"}
              data-plasmic-override={overrides.sheet}
              className={classNames(projectcss.all, sty.sheet)}
            >
              <div
                data-plasmic-name={"graphParentStack"}
                data-plasmic-override={overrides.graphParentStack}
                className={classNames(projectcss.all, sty.graphParentStack)}
              >
                <TimeSelectStack
                  data-plasmic-name={"timeSelectStack"}
                  data-plasmic-override={overrides.timeSelectStack}
                  className={classNames("__wab_instance", sty.timeSelectStack)}
                />

                <div
                  data-plasmic-name={"amountStack"}
                  data-plasmic-override={overrides.amountStack}
                  className={classNames(projectcss.all, sty.amountStack)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "$0.00",
                    value: args.totalBalance,
                    className: classNames(sty.slotTargetTotalBalance)
                  })}
                </div>
                <GraphStack
                  data-plasmic-name={"graphStack"}
                  data-plasmic-override={overrides.graphStack}
                  className={classNames("__wab_instance", sty.graphStack)}
                />

                <div
                  data-plasmic-name={"graphLine"}
                  data-plasmic-override={overrides.graphLine}
                  className={classNames(projectcss.all, sty.graphLine)}
                >
                  <div className={classNames(projectcss.all, sty.freeBox__zw5)}>
                    {renderPlasmicSlot({
                      defaultContents: "June 19, 2022",
                      value: args.startDate,
                      className: classNames(sty.slotTargetStartDate)
                    })}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__vb9MN)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "June 19, 2022",
                      value: args.endDate,
                      className: classNames(sty.slotTargetEndDate)
                    })}
                  </div>
                </div>
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"figmaPaste2"}
                data-plasmic-override={overrides.figmaPaste2}
                hasGap={true}
                className={classNames(projectcss.all, sty.figmaPaste2)}
              >
                <div
                  data-plasmic-name={"totalCollected"}
                  data-plasmic-override={overrides.totalCollected}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.totalCollected
                  )}
                >
                  {hasVariant(globalVariants, "screen", "large")
                    ? "Total Collected"
                    : "USD Balance"}
                </div>
                {renderPlasmicSlot({
                  defaultContents: (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ozjbT
                      )}
                    >
                      {"$0.00"}
                    </div>
                  ),

                  value: args.accountBalance,
                  className: classNames(sty.slotTargetAccountBalance)
                })}
                <div
                  data-plasmic-name={"text"}
                  data-plasmic-override={overrides.text}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text
                  )}
                >
                  {hasVariant(globalVariants, "screen", "large")
                    ? "Payouts"
                    : "Payouts"}
                </div>
                <div
                  data-plasmic-name={"payouts"}
                  data-plasmic-override={overrides.payouts}
                  className={classNames(projectcss.all, sty.payouts)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "$0.00",
                    value: args.payouts,
                    className: classNames(sty.slotTargetPayouts)
                  })}
                </div>
              </Stack__>
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__jDcAp)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__bj4Sp)}>
                <div className={classNames(projectcss.all, sty.freeBox__aZwtU)}>
                  <div
                    data-plasmic-name={"collectedPayments"}
                    data-plasmic-override={overrides.collectedPayments}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.collectedPayments
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "large")
                      ? "Payments"
                      : "Payments"}
                  </div>
                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View All"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"paymentCardStack"}
                  data-plasmic-override={overrides.paymentCardStack}
                  className={classNames(projectcss.all, sty.paymentCardStack)}
                >
                  <DashboardPaymentsCard
                    amount={"$1040.00"}
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardPaymentsCard__ylay
                    )}
                    client={"McDonalds"}
                  />

                  <DashboardPaymentsCard
                    amount={"$1040.00"}
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardPaymentsCard__qp4Ne
                    )}
                  />

                  <DashboardPaymentsCard
                    amount={"$1040.00"}
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardPaymentsCard__vfl3
                    )}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__dEvgQ)}>
                <div className={classNames(projectcss.all, sty.freeBox__ysgNd)}>
                  <div
                    data-plasmic-name={"debtors"}
                    data-plasmic-override={overrides.debtors}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.debtors
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "large")
                      ? "Debtors"
                      : "Contracts"}
                  </div>
                  <div
                    data-plasmic-name={"viewDetails2"}
                    data-plasmic-override={overrides.viewDetails2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails2
                    )}
                  >
                    {"View All"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"contractCardStack"}
                  data-plasmic-override={overrides.contractCardStack}
                  className={classNames(projectcss.all, sty.contractCardStack)}
                >
                  <DashboardContractsCard
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardContractsCard__gshG5
                    )}
                    client={"McDonalds client"}
                  />

                  <DashboardContractsCard
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardContractsCard__prgOx
                    )}
                  />

                  <DashboardContractsCard
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardContractsCard__rs3Bx
                    )}
                  />
                </div>
              </div>
            </Stack__>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "sheet",
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine",
    "figmaPaste2",
    "totalCollected",
    "text",
    "payouts",
    "collectedPayments",
    "viewDetails",
    "paymentCardStack",
    "debtors",
    "viewDetails2",
    "contractCardStack"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "sheet",
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine",
    "figmaPaste2",
    "totalCollected",
    "text",
    "payouts",
    "collectedPayments",
    "viewDetails",
    "paymentCardStack",
    "debtors",
    "viewDetails2",
    "contractCardStack"
  ],

  sheet: [
    "sheet",
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine",
    "figmaPaste2",
    "totalCollected",
    "text",
    "payouts"
  ],

  graphParentStack: [
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine"
  ],

  timeSelectStack: ["timeSelectStack"],
  amountStack: ["amountStack"],
  graphStack: ["graphStack"],
  graphLine: ["graphLine"],
  figmaPaste2: ["figmaPaste2", "totalCollected", "text", "payouts"],
  totalCollected: ["totalCollected"],
  text: ["text"],
  payouts: ["payouts"],
  collectedPayments: ["collectedPayments"],
  viewDetails: ["viewDetails"],
  paymentCardStack: ["paymentCardStack"],
  debtors: ["debtors"],
  viewDetails2: ["viewDetails2"],
  contractCardStack: ["contractCardStack"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDashboard__ArgProps,
          internalVariantPropNames: PlasmicDashboard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDashboard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDashboard";
  } else {
    func.displayName = `PlasmicDashboard.${nodeName}`;
  }
  return func;
}

export const PlasmicDashboard = Object.assign(
  // Top-level PlasmicDashboard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    sheet: makeNodeComponent("sheet"),
    graphParentStack: makeNodeComponent("graphParentStack"),
    timeSelectStack: makeNodeComponent("timeSelectStack"),
    amountStack: makeNodeComponent("amountStack"),
    graphStack: makeNodeComponent("graphStack"),
    graphLine: makeNodeComponent("graphLine"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    totalCollected: makeNodeComponent("totalCollected"),
    text: makeNodeComponent("text"),
    payouts: makeNodeComponent("payouts"),
    collectedPayments: makeNodeComponent("collectedPayments"),
    viewDetails: makeNodeComponent("viewDetails"),
    paymentCardStack: makeNodeComponent("paymentCardStack"),
    debtors: makeNodeComponent("debtors"),
    viewDetails2: makeNodeComponent("viewDetails2"),
    contractCardStack: makeNodeComponent("contractCardStack"),
    // Metadata about props expected for PlasmicDashboard
    internalVariantProps: PlasmicDashboard__VariantProps,
    internalArgProps: PlasmicDashboard__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicDashboard;
/* prettier-ignore-end */
